import React, { useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import FormPreferencias from "../../components/preferencias/FormPreferencias";
import Loader from "../../components/Loader";
import usePreferenciasStore from "../../store/preferenciasStore";
import { useParams, useNavigate } from 'react-router-dom';

const DetallePreferenciaPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isLoading, iniciar, actualizarId, setNavigate, limpiar } = usePreferenciasStore();


  useEffect(() => {
    limpiar();
    setNavigate(navigate);
    actualizarId(id);
    iniciar();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <FormPreferencias />}
      </MasterLayout>
    </>
  );
};

export default DetallePreferenciaPage;
